import { dispatcher, api } from 'react-structure-admin';

export const SUBSCRIPTION = 'SUBSCRIPTION';
export const SUBSCRIPTION_SET_VALUES = 'SUBSCRIPTION_SET_VALUES';
export const SUBSCRIPTION_SET_LOADING = 'SUBSCRIPTION_SET_LOADING';
export const SUBSCRIPTION_CURRENT_GET = 'SUBSCRIPTION_CURRENT_GET';
export const SUBSCRIPTION_CURRENT_GET_FINISHED =
  'SUBSCRIPTION_CURRENT_GET_FINISHED';

export const SUBSCRIPTION_OPEN_PURCHASE_PACKAGE =
  'SUBSCRIPTION_OPEN_PURCHASE_PACKAGE';
export const SUBSCRIPTION_CLOSE_PURCHASE_PACKAGE =
  'SUBSCRIPTION_CLOSE_PURCHASE_PACKAGE';

export const SUBSCRIPTION_OPEN_PACKAGE_LIST = 'SUBSCRIPTION_OPEN_PACKAGE_LIST';
export const SUBSCRIPTION_CLOSE_PACKAGE_LIST =
  'SUBSCRIPTION_CLOSE_PACKAGE_LIST';

export const SUBSCRIPTION_PURCHASE_PACKAGE = 'SUBSCRIPTION_PURCHASE_PACKAGE';
export const SUBSCRIPTION_PURCHASE_PACKAGE_FINISHED =
  'SUBSCRIPTION_PURCHASE_PACKAGE_FINISHED';

export const SUBSCRIPTION_BALANCE_DETAILS = 'SUBSCRIPTION_BALANCE_DETAILS';
export const SUBSCRIPTION_BALANCE_DETAILS_FINISHED =
  'SUBSCRIPTION_BALANCE_DETAILS_FINISHED';

export const SUBSCRIPTION_UPDATE = 'SUBSCRIPTION_UPDATE';
export const SUBSCRIPTION_UPDATE_FINISHED = 'SUBSCRIPTION_UPDATE_FINISHED';

export const setValues = (values) => (dispatch) => {
  dispatch(
    dispatcher.createAction(SUBSCRIPTION_SET_VALUES, 'subscriptions', values)
  );
};

export const setLoading = (loading) => (dispatch) => {
  dispatch(
    dispatcher.createAction(SUBSCRIPTION_SET_LOADING, 'subscriptions', loading)
  );
};

export const getActiveSubscription = () => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'subscriptions',
    actionType: SUBSCRIPTION_CURRENT_GET,
    effect: async () => api.fetch('subscriptions/current-subscription')
  });
};

export const openPurchasePackage = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(SUBSCRIPTION_OPEN_PURCHASE_PACKAGE, 'subscriptions')
  );
};

export const closePurchasePackage = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(
      SUBSCRIPTION_CLOSE_PURCHASE_PACKAGE,
      'subscriptions'
    )
  );
};

export const postPurchasePackage = (
  packageId,
  paymentMethod,
  onSuccess
) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'subscriptions',
    actionType: SUBSCRIPTION_PURCHASE_PACKAGE,
    onSuccess,
    effect: async () =>
      api.post(
        `subscriptions/purchase-package?packageId=${packageId}`,
        paymentMethod
      )
  });
};

export const getBalanceDetails = () => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'subscriptions',
    actionType: SUBSCRIPTION_BALANCE_DETAILS,
    effect: async () => api.fetch('subscriptions/balance-details')
  });
};

export const openPackageList = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(SUBSCRIPTION_OPEN_PACKAGE_LIST, 'subscriptions')
  );
};

export const closePackageList = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(SUBSCRIPTION_CLOSE_PACKAGE_LIST, 'subscriptions')
  );
};

export const updateSubscription = (
  subscriptionId,
  payload = {},
  onSuccess,
  onFail
) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'subscriptions',
    actionType: SUBSCRIPTION_UPDATE,
    payload,
    effect: async () => api.put(`subscriptions/${subscriptionId}`, payload),
    onSuccess,
    onFail
  });
};
